var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconChatBubble = function SvgIconChatBubble(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.032 14.583-1.478 1.479q-.317.316-.727.144-.41-.171-.41-.62V3.756q0-.563.388-.95.39-.39.951-.39h12.488q.563 0 .95.39.39.387.39.95v9.488q0 .563-.39.95-.387.39-.95.39zM4.583 13.5h11.66a.25.25 0 0 0 .177-.08.25.25 0 0 0 .08-.176V3.756a.25.25 0 0 0-.08-.176.25.25 0 0 0-.176-.08H3.756a.25.25 0 0 0-.176.08.25.25 0 0 0-.08.176v10.835z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconChatBubble);
export { ForwardRef as ReactComponent };